export enum CssClassName {
  KIOSK = 'kiosk',
}
